<div class="AmInputFormph" [formGroup]="formGroup">
  <div class="AmInputForm-input" [ngClass]="{ 'AmInputForm-input--fullSize': inputFullSize }">
    <div class="PhoneSection row">
       <div class="col-md-3 col-sm-12 col-xs-12 ">
         <div class="PhoneInput-contentCode" (click)="showModal()">
            {{ countrySelected }}
           <span class="PhoneInput-arrow-pos"><img class="PhoneInput-arrow"  src="./assets/images/forms/chevron-down.svg" alt="arrow"></span>
         </div>
       </div>
       <div class="col-md-7 col-sm-12 col-xs-12">
         <input
           class="form-control"
           [formControl]="textControl"
           [placeholder]="placeholder | translate"
           [currentFormGroup]="formGroup"
           [formControlName]="nameInput"
           [id]="nameInput"
           [isFloat]="false"
           [showNav]="true"
           appAmKeyboard
           autocomplete="off"
           [maxlength]="maxlength"
           [ngClass]="{
              'input--error': (textControl?.touched && textControl.invalid),
               'am-input-rb': className == 'am-input-rb'
          }"
           [type]="typeInput"
           [(ngModel)]="val"
           [nameList]="nameList"
         />
       </div>
     </div>


   </div>
      <app-form-error-message
      [style]="styleInput"
      [fieldInput]="textControl"
      [errorRequired]="errorRequired"
      [errorPattern]="errorPattern"
      [className]="classNameMessage">
    </app-form-error-message>

    </div>
